import { hasReach } from '../common/utils';
import { onMounted, onBeforeUnmount, nextTick, unref } from 'vue-demi';

// 处理自动播放
export default (swiper, el) => {
    // 不支持IntersectionObserver，不处理
    if (!window.IntersectionObserver) {
        return;
    }

    // IntersectionObserver 实例
    let ioIns = null;

    const initObserver = () => {
        const $el = unref(el);
        // 开始监听
        ioIns = hasReach($el, (hasReached) => {
            // hasReached true 进入视口开始播放
            // hasReached false 离开视口停止播放
            hasReached ? swiper.value?.autoplay.start() : swiper.value?.autoplay.stop();
        });
    };

    const destroyObserver = () => {
        ioIns?.disconnect();
        ioIns = null;
    };

    onMounted(() => {
        nextTick(initObserver);
    });

    // 组件销毁时，移除监听
    onBeforeUnmount(destroyObserver);
};
